import { render, staticRenderFns } from "./PosicaoFiscalForm.vue?vue&type=template&id=505b016a&scoped=true&"
import script from "./PosicaoFiscalForm.vue?vue&type=script&lang=js&"
export * from "./PosicaoFiscalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b016a",
  null
  
)

export default component.exports